import { RouteConfig } from 'vue-router';
import DefaultLayout from '@/views/DefaultLayout.vue';
import PartnerSales from '@/views/contents/partner/PartnerSales.vue';
import PartnerSalesIframe from '@/views/contents/partner/PartnerSalesIframe.vue';
import Settlements from '@/views/contents/partner/Settlements.vue';
import SettlementsIframe from '@/views/contents/partner/SettlementsIframe.vue';
import PartnerRegisterIndex from '@/views/contents/partner/register/PartnerRegisterIndex.vue';
import PartnerRegisterIndexIframe from '@/views/contents/partner/register/PartnerRegisterIndexIframe.vue';
import PartnerRegisterNew from '@/views/contents/partner/register/new/PartnerRegisterNew.vue';
import PartnerRegisterNewIframe from '@/views/contents/partner/register/new/PartnerRegisterNewIframe.vue';
import PartnerRegisterSearch from '@/views/contents/partner/register/contract/PartnerRegisterSearch.vue';
import PartnerRegisterSearchIframe from '@/views/contents/partner/register/contract/PartnerRegisterSearchIframe.vue';
import PartnerRegisterSearchDetail from '@/views/contents/partner/register/contract/PartnerRegisterSearchDetail.vue';
import PartnerRegisterCopySearch from '@/views/contents/partner/register/copy/PartnerRegisterCopySearch.vue';
import PartnerRegisterCopySearchIframe from '@/views/contents/partner/register/copy/PartnerRegisterCopySearchIframe.vue';
import PartnerRegisterCopyDetail from '@/views/contents/partner/register/copy/PartnerRegisterCopyDetail.vue';
import PartnerModification from '@/views/contents/partner/modification/PartnerModification.vue';
import PartnerModificationIframe from '@/views/contents/partner/modification/PartnerModificationIframe.vue';
import PartnerList from '@/views/contents/partner/list/PartnerList.vue';
import PartnerListIframe from '@/views/contents/partner/list/PartnerListIframe.vue';
import PartnerNoticeListIframe from '@/views/contents/partner/notice/PartnerNoticeListIframe.vue';

// NOTE: path 가 '/configuration/partner'인 이유 => LNB상 partner는 configuration의 하위에 있음.
export default (): RouteConfig => {
  return {
    path: '/configuration/partner',
    name: 'Partner',
    component: DefaultLayout,
    children: [
      {
        path: 'sales-prev',
        name: 'PartnerSalesPrev',
        component: PartnerSales,
        meta: {
          excelCreateMenuKey: 'PRO_SETTLEMENT_DAILY_SALE',
        },
      },
      {
        path: 'sales',
        name: 'PartnerSales',
        component: PartnerSalesIframe,
      },
      {
        path: 'settlements-prev',
        name: 'SettlementsPrev',
        component: Settlements,
      },
      {
        path: 'settlements',
        name: 'Settlements',
        component: SettlementsIframe,
      },
      // 파트너 조회
      {
        path: 'search-prev',
        name: 'PartnerListPrev',
        component: PartnerList,
      },
      {
        path: 'search',
        name: 'PartnerList',
        component: PartnerListIframe,
      },
      // 파트너 등록
      {
        path: 'register-prev',
        name: 'PartnerRegisterIndexPrev',
        component: PartnerRegisterIndex,
      },
      {
        path: 'register',
        name: 'PartnerRegisterIndex',
        component: PartnerRegisterIndexIframe,
      },
      // 파트너 신규등록
      {
        path: 'register/new-prev',
        name: 'PartnerRegisterNewPrev',
        component: PartnerRegisterNew,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 신규등록'],
        },
      },
      {
        path: 'register/new',
        name: 'PartnerRegisterNew',
        component: PartnerRegisterNewIframe,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 신규등록'],
        },
      },
      // 파트너 검색/등록 > 사업자 정보 검색
      {
        path: 'register/search-prev',
        name: 'PartnerRegisterSearchPrev',
        component: PartnerRegisterSearch,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 검색/등록'],
        },
      },
      {
        path: 'register/search',
        name: 'PartnerRegisterSearch',
        component: PartnerRegisterSearchIframe,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 검색/등록'],
        },
      },
      // 파트너 검색/등록 > 세부사항 확인/입력
      {
        path: 'register/search/:partnerNo',
        name: 'PartnerRegisterSearchDetail',
        component: PartnerRegisterSearchDetail,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 검색/등록'],
        },
      },
      // 파트너 복사등록 > 사업자 정보 검색
      {
        path: 'register/copy-prev',
        name: 'PartnerRegisterCopySearchPrev',
        component: PartnerRegisterCopySearch,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 복사등록'],
        },
      },
      {
        path: 'register/copy',
        name: 'PartnerRegisterCopySearch',
        component: PartnerRegisterCopySearchIframe,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 복사등록'],
        },
      },
      // 파트너 복사등록 > 세부사항 확인/입력
      {
        path: 'register/copy/:partnerNo',
        name: 'PartnerRegisterCopyDetail',
        component: PartnerRegisterCopyDetail,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 등록', '파트너 복사등록'],
        },
      },
      // 파트너 수정
      {
        path: 'modification-prev/:partnerNo',
        name: 'PartnerModificationPrev',
        component: PartnerModification,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 수정'],
        },
      },
      {
        path: 'modification/:partnerNo',
        name: 'PartnerModification',
        component: PartnerModificationIframe,
        meta: {
          breadcrumb: ['설정', '파트너 관리', '파트너 수정'],
        },
      },
      // 파트너 공지사항 관리
      {
        path: 'notice',
        name: 'PartnerNoticeListIframe',
        component: PartnerNoticeListIframe,
      },
    ],
  };
};
